
import { useEffect, useState } from 'react';
import { Car } from 'lucide-react';

interface LoadingAnimationProps {
  onComplete?: () => void;
  isNewConversation?: boolean;
}

export const LoadingAnimation = ({ onComplete, isNewConversation }: LoadingAnimationProps) => {
  const [loadingStep, setLoadingStep] = useState(0);

  const loadingMessages = isNewConversation 
    ? ["Starting a new conversation...", "Preparing your assistant..."]
    : [
        "Warming up the engines...",
        "Checking the latest car market trends...",
        "Analyzing vehicle options...",
        "Getting ready to help you find your perfect car..."
      ];

  useEffect(() => {
    const animateLoading = async () => {
      for (let i = 0; i < loadingMessages.length; i++) {
        setLoadingStep(i);
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      onComplete?.();
    };

    animateLoading();
  }, [onComplete, loadingMessages.length]);

  return (
    <div className="space-y-6 max-w-3xl mx-auto w-full">
      {loadingMessages.slice(0, loadingStep + 1).map((message, index) => (
        <div 
          key={index}
          className={`animate-fade-in transition-opacity duration-300 ${
            index === loadingStep ? 'opacity-100' : 'opacity-40'
          }`}
        >
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 rounded-lg bg-blue-50 flex items-center justify-center">
              <Car className="w-4 h-4 text-blue-500" />
            </div>
            <div className="space-y-1.5 flex-1">
              <div className="text-sm text-foreground/80">{message}</div>
              <div className="h-1 w-full bg-blue-50 rounded-full overflow-hidden">
                <div 
                  className="h-full bg-blue-200 transition-all duration-700 ease-in-out"
                  style={{ 
                    width: `${((index + 1) / loadingMessages.length) * 100}%`
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
